import { Component, OnInit } from '@angular/core';
import { PosHttpService } from '../../services/pos.http.service';
import { FnModalService, FnTableConfig, FnTableMetaData, FnToasterService, FnUtilService, TABLE_ACTION_TYPE, TableAction } from 'foundation';
import { MailTeam } from '../../modal/entity.modal';
import { Subject } from 'rxjs';
import { MailTeamModalComponent } from './eomailteam-modal/eomailteam-modal.component';

@Component({
    selector: 'mailteam',
    templateUrl: './mailteam.component.html',
    styleUrl: './mailteam.component.scss'
})
export class MailTeamComponent implements OnInit {
    constructor(private posHttpSvcs: PosHttpService, private toastr: FnToasterService, private fnModalSvcs: FnModalService, private fnutilservice: FnUtilService, private toaster: FnToasterService) {

    }
    ngOnInit(): void {
        this.loadData();
    }

    uiMap = {
        isDataLoaded: false,
    };
    showData = false;

    config: FnTableConfig = {
        uniqueKey: 'primaryKey',
        defaultSortKey: 'primaryKey',
        tableAction: new Subject<TableAction>(),
    };

    rowMetaArray: FnTableMetaData[] = [
        {
            key: 'primaryKey',
            description: 'Primary Key',
            isHidden: true,
            isSortable: true,
            type: 'number',
        },
        {
            key: 'id',
            description: 'Mail Name',
            type: 'string',
            isSortable: true,
        },
        {
            key: 'name',
            description: 'Default Esc Email ID',
            type: 'string',
            isSortable: true,
        },

    ];

    mailTeamArray: MailTeam[] = [];


    loadData() {
        this.posHttpSvcs.authGet('v1/ui/loadEoMailTeam', 'loadEoMailTeam').subscribe((resp: any) => {
            if (resp.isError) {
                this.toastr.error('Invalid loadEoMailTeam ⚠️');
                return;
            }
            this.mailTeamArray = resp.data;
            this.showData = false;
            this.refreshTableData();
            this.uiMap.isDataLoaded = true;
        });
    }
    updateRowAction(event: MailTeam) {
        const mailTeamModal = this.fnModalSvcs.openCustomModal(MailTeamModalComponent, {
            data: {
                eoMailTeam: event
            },
            hasBackdrop: true,
            width: '500px',
        })
        mailTeamModal.afterClosed().subscribe((objectHash) => {
            if(objectHash != undefined){
            this.addUpdateEOMailTeam(objectHash);
            }
        });
    }
    deleteRowAction(event: MailTeam) {
        const dialogRef = this.fnModalSvcs.openConfirmModal({
            isConformationMdl: true,
            content: 'Are you sure you want to delete EOMailTeam ?',
            type: 'danger',
        });
        dialogRef.afterClosed().subscribe(doAction => {
            if (doAction) {
                this.posHttpSvcs.authDeleteWithBody('v1/ui/deleteMailTeam', event.primaryKey, event).subscribe(resp => {
                    this.loadData();
                })
            }
        });
    }

    openActionMdl() {
        const mailTeamModal = this.fnModalSvcs.openCustomModal(MailTeamModalComponent, {
            data: {
            },
            hasBackdrop: true,
            width: '500px',
        })
        mailTeamModal.afterClosed().subscribe((objectHash) => {
            if(objectHash != undefined){
                this.addUpdateEOMailTeam(objectHash);
            }
            
        });
    }

    addUpdateEOMailTeam(objectHash: any) {
        this.posHttpSvcs.authPut('v1/ui/saveMailTeam', 'saveMailTeam', objectHash).subscribe(resp => {
            if (resp.isError) {
                this.toastr.error(' EOMailTeam is not added ⚠️');
                return;
            } else {
                this.toastr.success("added successfully");
                this.loadData();
            }
        })

    }

    refreshTableData() {
        if (this.config.tableAction.closed) {
            this.config.tableAction = new Subject<TableAction>();
        }
        this.config.tableAction.next({
            data: this.mailTeamArray,
            action: TABLE_ACTION_TYPE.REFRESH,
        });
    }
}
